import React from "react";
import GradeAttributeCard from "../GradeAttributeCard";
import { RenderListWrapper } from "./styles";

function RenderList({ list }) {
  if (!list) return;
  return (
    <div className="disease-wise-sub-limit-grid-css">
      {list.map((item) => (
        <GradeAttributeCard
          key={item?.disease}
          title={item?.disease}
          limit={item?.limit}
          remarks={item?.remarks}
        />
      ))}
    </div>
  );
}

export default RenderList;
